module.exports = __webpack_public_path__ + "static/media/iconExercisesActive.abe0f21a.svg";